import _ from 'underscore';

import {assert} from 'Asserts';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import {Note, NoteLinkedObjectType} from 'notebook/util/NoteUtilConstants';

import {EditorMixinInterface} from '../Editor';
import convertStructuredTableForPaste from '../structured-tables/convertStructuredTableForPaste';

export default function convertStoichiometryGroupForPaste(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any,
  name: string | null,
  component: Partial<EditorMixinInterface>,
  usedTableNames: Array<string>,
  destinationFileId: string,
  isConfig: boolean | undefined,
  note?: Note
): void {
  assert(name != null, 'Stoichiometry group paste requires a name to avoid duplicate table name conflicts');

  // Clear the reaction link — the pasted copy is independent from the original reaction.
  item.item.groupMetadata = {reactionId: null};

  for (let i = 0; i < item.item.containedNoteParts.length; i++) {
    const containedNotePart = item.item.containedNoteParts[i];
    const containedItem = containedNotePart.item;
    if (component.props!.getType(containedItem) === NoteLinkedObjectType.STRUCTURED_TABLE) {
      assert(
        containedItem.kind === StructuredTableKind.STOICHIOMETRY,
        `Expected stoichiometry table but got ${containedItem.kind}`
      );
      const newContainedNotePart = convertStructuredTableForPaste(containedNotePart, {
        usedTableNames,
        destinationFileId,
        isDestinationConfig: isConfig,
        note,
      }).item;
      newContainedNotePart.item.name = name;
      newContainedNotePart.cid = _.uniqueId('note-part');
      item.item.containedNoteParts[i] = newContainedNotePart;
    }
  }
}
